import React, { useState, useEffect } from 'react';
import { ReactComponent as MixEngineerIcon } from '../../../assets/images/icons/mixing-icon.svg'
import { ReactComponent as MasteringEngineerIcon } from '../../../assets/images/icons/mastering-icon.svg'
import { ReactComponent as MixEnhancerIcon } from '../../../assets/images/icons/mix-enhancer-icon.svg'
import { ReactComponent as MixAnalystIcon } from '../../../assets/images/icons/mix-analyst-icon.svg'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { showToast } from '../../../helper/ShowToast';

const StudioGoals = () => {
  const navigate = useNavigate()
  const [selectedGoal, setSelectedGoal] = useState(null);
  // read persisted last active goal from redux so we can resume where the user left off
  const lastActiveGoal = useSelector((state) => state.audioEngineer?.lastActiveGoal);
  useEffect(() => {
    if (lastActiveGoal) {
      const map = {
        mixing: '/admin/urstudio/mixing-engineer',
        mastering: '/admin/urstudio/audio-engineer',
        enhancer: '/admin/urstudio/mix-enhancer',
        analyst: '/admin/urstudio/mix-analyst'
      };
      const route = map[lastActiveGoal] || '/admin/urstudio';
      navigate(route);
    }
  }, [lastActiveGoal, navigate]);

  const goals = [
    {
      id: 'mixing',
      title: 'Mixing Engineer',
      icon: MixEngineerIcon,
      route: '/admin/urstudio/mixing-engineer'
    },
    {
      id: 'mastering',
      title: 'Mastering Engineer',
      icon: MasteringEngineerIcon,
      route: '/admin/urstudio/audio-engineer'
    },
    {
      id: 'enhancer',
      title: 'Mix Enhancer + Stem Processor',
      icon: MixEnhancerIcon,
      route: '/admin/urstudio/mix-enhancer'
    },
    {
      id: 'analyst',
      title: 'Mix Analyst',
      icon: MixAnalystIcon,
      route: '/admin/urstudio/mix-analyst'
    }
  ];

  const handleNavigate = (route) => {
    // if(route === '/admin/urstudio/mix-enhancer' || route === '/admin/urstudio/mix-analyst') {
    //   showToast('info', 'These features are coming soon! Stay tuned');
    // } else {
      navigate(route);
    // }
  }

  return (
    <div>
      <div className="text-center mb-6">
        <h1 className="text-xl sm:text-2xl lg:text-2xl font-bold text-white mb-2 sm:mb-3">
          Choose Your Audio Engineering Goal
        </h1>
        <p className="text-blue-300 text-sm sm:text-base">
          Enhance your tracks and get them release-ready with smart, AI-powered tools.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 lg:gap-5">
        {goals.map((goal) => {
          const GoalIcon = goal.icon;
          return (
          <button
            key={goal.id}
            data-tour={`studio-goal-${goal.id}`}
            onClick={() => {
              setSelectedGoal(goal.id)
              handleNavigate(goal.route)
            }}
            className={`${selectedGoal === goal.id ? 'bg-theme_clr2' : 'bg-white'} rounded-xl sm:rounded-2xl p-6 flex flex-col items-center justify-center transition-all duration-300 hover:scale-105 hover:shadow-2xl ${selectedGoal === goal.id ? 'ring-4 ring-blue-400 shadow-2xl' : 'shadow-lg'
              }`}
          >
            <div className="mb-3 sm:mb-4 text-theme_clr1">
              <GoalIcon
                aria-label={goal.title}
                className="w-12 h-12"
              />
            </div>
            <h2 className="text-base sm:text-lg lg:text-xl font-bold text-theme_clr1 text-center">
              {goal.title}
            </h2>
          </button>
          );
        })}
      </div>

      {/* {selectedGoal && (
          <div className="mt-6 sm:mt-8 text-center">
            <button className="bg-white text-theme_clr1 font-bold text-sm sm:text-base px-6 sm:px-8 py-2.5 sm:py-3 rounded-full hover:bg-blue-50 transition-colors">
              Continue with {goals.find(g => g.id === selectedGoal)?.title}
            </button>
          </div>
        )} */}
    </div>
  );
};

export default StudioGoals;